import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Button from 'src/presentations/components/atom/button';
import { isShipmentUnderReview } from 'src/utils/invoiceStatus';
import { useInvoiceContext } from '../../InvoiceContextProvider';
import { useShipmentSelector } from '../../ShipmentSelector';
import { useNoRateCardSelector } from '../../noRateCard/Selector';
import { useRecalculationToastSelector } from '../../recalculationToast/RecalculationToastSelector';

interface ShipmentActionButtonsProps {
  actions: {
    onConfirm: () => void;
  };
}

export const ShipmentActionButtons: React.FC<ShipmentActionButtonsProps> = ({ actions }) => {
  const { onConfirm } = actions;
  // Get data from hooks
  const { invoiceSummary } = useInvoiceContext();
  const { shipment } = useShipmentSelector();
  const { showNoRateCard, isHaveDraft } = useNoRateCardSelector();
  const { isLoading: isConfirmLoading } = useRecalculationToastSelector();

  if (!shipment || isShipmentUnderReview(invoiceSummary, shipment.shipmentInvoiceId)) {
    return null;
  }

  const isProcurement = invoiceSummary?.currentMainRole === 'PROCUREMENT';
  const isSupplyChain = invoiceSummary?.currentMainRole === 'SUPPLY_CHAIN';
  const isOpsAdmin = invoiceSummary?.currentMainRole === 'OPS_ADMIN';

  const isActionNoRateCard =
    (isProcurement || isSupplyChain || isOpsAdmin) &&
    shipment?.status === 'FLAGGED' &&
    (shipment?.currentDeviationWorkflow === 'PROCUREMENT_NO_CONTRACT_REVIEW' || shipment?.currentDeviationWorkflow === 'OPS_ADMIN_NO_CONTRACT_REVIEW');

  const isActionConfirmReview =
    shipment?.status === 'FLAGGED' &&
    shipment?.currentDeviationWorkflow === `${invoiceSummary?.currentMainRole}_REVIEW` &&
    !invoiceSummary?.nextWorkflowAction &&
    shipment?.nextWorkflowAction;

  return (
    <>
      {isActionNoRateCard && (
        <div className='relative'>
          <Button
            variant={isHaveDraft || shipment.status === 'REJECTED' ? 'secondary' : 'warning_light'}
            rounded='small'
            className='min-w-min'
            onClick={showNoRateCard}
          >
            {isHaveDraft || shipment.status === 'REJECTED' ? 'Edit NRCF' : 'Review NRCF'}
          </Button>
        </div>
      )}

      {isActionConfirmReview && (
        <div className='relative'>
          <Button variant='primary_light' className='min-w-min' rounded='small' disabled={isConfirmLoading} onClick={onConfirm} isLoading={isConfirmLoading}>
            {isConfirmLoading ? <CircularProgress size={24} color='inherit' /> : 'Confirm'}
          </Button>
        </div>
      )}
    </>
  );
};
